import { useT } from 'apprise-frontend-core/intl/language';
import { AvlDeclaration, Revocation } from './model';

import { avlType, RevokeIcon } from '#avl/constants';
import { AvlListEntry } from '#avl/list';
import { useVesselCalls } from '#vessel/calls';
import { DetailContext } from '#vessel/context';
import { noTenant } from 'apprise-core/tenant';
import { useOracle } from 'apprise-frontend-iam/authz/oracle';
import { useLogged } from 'apprise-frontend-iam/login/logged';
import { useUserStore } from 'apprise-frontend-iam/user/store';
import { UserBox } from 'apprise-frontend-iam/user/userbox';
import { Button } from 'apprise-ui/button/button';
import { DateBox } from 'apprise-ui/date/datebox';
import { Drawer, DrawerProps } from 'apprise-ui/drawer/drawer';
import { Form } from 'apprise-ui/form/form';
import { TextBox } from 'apprise-ui/textbox/textbox';
import { Explainer } from 'apprise-ui/utils/explainer';
import { useContext, useState } from 'react';
import { Fragment } from 'react/jsx-runtime';



export const RevokePanel = (props: DrawerProps & {

    entry: AvlListEntry | undefined,

}) => {


    const t = useT()

    const { entry } = props

    return <Drawer unmountOnClose width={600} open={!!entry} title={t("avl.revoke_title")} onClose={props.onClose}>
        <Inner {...props} />
    </Drawer>
}


const Inner = (props: DrawerProps & {

    entry: AvlListEntry | undefined,

}) => {


    const t = useT()

    const { entry } = props

    const users = useUserStore().all().filter(u => u.tenant === entry?.declaration.tenant || u.tenant === noTenant)

    const calls = useVesselCalls()

    const { setHistory } = useContext(DetailContext)

    const logged = useLogged()

    const oracle = useOracle()

    const updateRevision = async () => {

        if (!entry?.revision)
            return


        const updatedRevision = {
            ...entry.revision,
            [avlType]: {
                ...entry.revision.avl,
                declarations: entry.revision.avl.declarations.map(d => d !== entry.declaration ? d : {
                    ...entry.declaration,

                    revoked: d.revoked ? undefined : revocation
                } as AvlDeclaration)

            }
        }


        await calls.updateRecordInPlace(updatedRevision)

        setHistory(s => s.map(r => r.id !== updatedRevision.id ? r : updatedRevision))

        console.log('revoking/restoring', entry.declaration, "revision", entry.revision)

        props.onClose?.()

    }

    const initialRevocation: Revocation = {
        revokedBy: logged.username,
        revokedOn: new Date().toISOString(),

        ...entry?.declaration.revoked
    }

    const [revocation, setRevocation] = useState<Revocation>(initialRevocation)

    return entry && <Fragment >

        <Explainer icon={<RevokeIcon size={130} full color='orangered' />}>
            <div>{t('avl.revoke_explainer')}</div>
        </Explainer>

        <br />

        <Form centered  >

            <DateBox label={t('avl.revoke_date')} noClear onChange={value => setRevocation(s => ({ ...s, revokedOn: value! }))} readonly={!!entry.declaration.revoked || oracle.isAdmin()}>
                {revocation.revokedOn}
            </DateBox>

            <UserBox users={users} label={t('avl.revoke_user')} noClear width='40%' onChange={value => setRevocation(s => ({ ...s, revokedBy: value! }))} readonly={!!entry.declaration.revoked || !oracle.isAdmin()}>
                {revocation.revokedBy}
            </UserBox>

            <TextBox label={t('avl.revoke_comment')} msg={t('avl.revoke_comment_msg')} multi={{ start: 4, end: 6 }} width='80%' onChange={value => setRevocation(s => ({ ...s, comment: value }))} readonly={!!entry.declaration.revoked}>
                {revocation.comment}
            </TextBox>

        </Form>

        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 75 }}>
            <Button disabled={!!entry.declaration.revoked} onClick={updateRevision} type='primary'>{t('avl.revoke_btn')}</Button>
            &nbsp;&nbsp;&nbsp;
            <Button enabled={!!entry.declaration.revoked} onClick={updateRevision} type='primary'>{t('avl.restore_btn')}</Button>
        </div>

    </Fragment>
}

